import type * as React from 'react';

import * as api from '@gitbook/api-client';
import { Picker, type PickerItemData } from '@gitbook/react-uikit';
import { Description, FieldGroup, Group, Label, Panel, PanelBody } from '@gitbook/spine-react';

import type { SitesCustomizationPanelProps } from '../types';

/**
 * Settings to configure how external links open.
 */
export function ExternalLinksSettings(props: SitesCustomizationPanelProps): React.ReactElement {
    const { settings, setSettings } = props;

    return (
        <Panel aria-label="External links">
            <PanelBody>
                <FieldGroup orientation="horizontal">
                    <Group>
                        <Label>External links</Label>
                        <Description>Choose how external links open.</Description>
                    </Group>
                    <Picker<api.SiteExternalLinksTarget>
                        value={settings.externalLinks.target}
                        items={OPTIONS}
                        onValueChange={(value) => {
                            setSettings((prev) => ({
                                ...prev,
                                externalLinks: { target: value },
                            }));
                        }}
                    />
                </FieldGroup>
            </PanelBody>
        </Panel>
    );
}

const OPTIONS: PickerItemData<api.SiteExternalLinksTarget>[] = [
    { value: api.SiteExternalLinksTarget.Self, label: 'Same tab' },
    { value: api.SiteExternalLinksTarget.Blank, label: 'New tab' },
];
